<div class="details-wrapper">
  <a
    class="show-details-link"
    (click)="showDetails = !showDetails"
    (keydown.enter)="showDetails = !showDetails"
    tabindex="0"
    role="button"
    [attr.aria-expanded]="showDetails"
  >
    <span i18n="@@basketPanelTotalShowDetails">Show details</span>
    <span class="sr-only"> for {{ detail?.hotelName }}</span>
    <i
      class="ico"
      [class.ico-chevron-down]="!showDetails"
      [class.ico-chevron-up]="showDetails"
      aria-hidden="true"
    ></i>
  </a>
  @if (showDetails) {
    <div class="summary">
      <dl class="details-grid">
        @if (detail?.rooms[0]?.roomType; as roomType) {
          <div class="details-grid__item">
            <dt><strong i18n="@@ShowDetailsRoomType">Room type</strong>:</dt>
            <dd>{{ roomType }}</dd>
          </div>
        }
        @if (detail?.rooms[0]?.rateDescription; as description) {
          <div class="details-grid__item">
            <dt><strong i18n="@@ShowDetailsDescription">Description</strong>:</dt>
            <dd>{{ description }}</dd>
          </div>
        }
        @if (detail?.rooms[0]?.nights; as amountOfNights) {
          <div class="details-grid__item">
            <dt><strong i18n="@@ShowDetailsAmountOfNights">Amount of nights</strong>:</dt>
            <dd>{{ detail?.rooms[0].nights.length }}</dd>
          </div>
        }
      </dl>
    </div>
  }
</div>
